import Categories from '@/components/tournaments/categories';
import { useLoaderData, useRouteLoaderData } from 'react-router';
import { tournamentRouteId } from './layout';
import { categoryApi } from '@repo/api-client';

function Pending() {
  const { categories } = useLoaderData<typeof loader>();
  const { tournament } = useRouteLoaderData(tournamentRouteId);
  return <Categories tournament={tournament} categories={categories} />;
}

const loader = async () => {
  const categories = await categoryApi.getAll();
  return { categories: categories.results };
};

export const route = {
  index: true,
  path: 'pending',
  element: <Pending />,
  loader: loader,
};
